<template>
  <div :id="componentId" class="sp3-module-1" :style="moduleStyle">
    <div class="sp3-banner-wrap">
      <img
        v-if="bannerUrl"
        class="sp3-banner-image"
        referrerpolicy="no-referrer"
        :src="bannerUrl"
      >
      <div v-else class="sp3-banner-placeholder">请配置大图</div>
    </div>

    <div class="sp3-content" :style="contentStyle">
      <div class="sp3-content-inner">
        <div class="sp3-left-section">
          <div class="sp3-left-title">{{ leftTitle || '聚焦两会' }}</div>
          <div class="sp3-focus-list">
            <div
              v-for="(item, index) in displayLeftList"
              :key="index"
              class="sp3-focus-item"
            >
              <div class="sp3-focus-image-wrap" @click="goTo(item.url)">
                <img
                  v-if="item.imageUrl"
                  class="sp3-focus-image"
                  referrerpolicy="no-referrer"
                  :src="item.imageUrl"
                >
                <div v-else class="sp3-focus-image-placeholder">图片</div>
              </div>
              <div class="sp3-focus-main-title" @click="goTo(item.url)">{{ item.title || '标题' }}</div>
              <div class="sp3-focus-sub-list">
                <div
                  v-for="(sub, subIndex) in item.subList"
                  :key="subIndex"
                  class="sp3-focus-sub-row"
                >
                  <div class="sp3-focus-sub-item" @click="goTo(sub.url)">
                    {{ sub.title || '子标题' }}
                  </div>
                  <div v-if="subIndex < item.subList.length - 1" class="sp3-focus-sub-divider" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="sp3-right-section">
          <div class="sp3-right-header">
            <span class="sp3-right-title-text">{{ rightTitle || '全部两会' }}</span>
          </div>
          <div class="sp3-right-card">
            <div class="sp3-right-list">
              <div
                v-for="(item, index) in displayRightList"
                :key="index"
                class="sp3-right-item"
                @click="goTo(item.url)"
              >
                <div class="sp3-right-date">
                  <span class="sp3-right-day">{{ item.day || '09' }}</span>
                  <span class="sp3-right-month">{{ item.month || '2026-06' }}</span>
                </div>
                <div class="sp3-right-divider" />
                <div class="sp3-right-item-title">{{ item.title || '标题' }}</div>
              </div>
            </div>
          </div>
          <div class="sp3-right-bottom-bar" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
const DEFAULT_LEFT_ITEM = {
  imageUrl: '',
  title: '第七届中国品牌发展论坛系列活动现',
  newsCode: '',
  url: '',
  subList: [
    { title: '必须深刻把握中国式现代化对教育', newsCode: '', url: '' },
    { title: '必须深刻把握中国式现代化对教育', newsCode: '', url: '' },
    { title: '必须深刻把握中国式现代化对教育', newsCode: '', url: '' }
  ]
}

const DEFAULT_RIGHT_ITEM = {
  day: '09',
  month: '2026-06',
  title: '第七届中国品牌发展论坛系列活动现场花絮!',
  newsCode: '',
  url: ''
}

export default {
  name: 'SpThreeModule1',
  props: {
    componentId: {
      type: String,
      default: 'sp_three_module_1'
    }
  },
  data() {
    return {
      bannerUrl: '',
      bgColor: '#FFF5F0',
      leftTitle: '聚焦两会',
      rightTitle: '全国两会',
      rightList: Array.from({ length: 6 }, () => ({ ...DEFAULT_RIGHT_ITEM })),
      leftList: [
        { ...DEFAULT_LEFT_ITEM },
        { ...DEFAULT_LEFT_ITEM }
      ]
    }
  },
  computed: {
    displayRightList() {
      return (this.rightList || []).slice(0, 6)
    },
    displayLeftList() {
      const list = (this.leftList || []).slice(0, 2).map(item => ({
        ...item,
        subList: (item.subList || []).slice(0, 3)
      }))
      if (list.length < 2) {
        while (list.length < 2) {
          list.push({ ...DEFAULT_LEFT_ITEM })
        }
      }
      return list
    },
    moduleStyle() {
      return {
        backgroundColor: this.bgColor
      }
    },
    contentStyle() {
      return {
        backgroundColor: this.bgColor
      }
    }
  },
  methods: {
    goTo(url) {
      if (!url) return
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.sp3-module-1 {
  position: relative;
  width: 2000px;
  min-width: 2000px;
  max-width: 2000px;
  left: 50%;
  transform: translateX(-50%);
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
}

.sp3-banner-wrap {
  position: relative;
  width: 2000px;
  height: 650px;
  overflow: hidden;
  background: #E0E0E0;
}

.sp3-banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.sp3-banner-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
}

.sp3-content {
  position: relative;
  width: 2000px;
  padding-bottom: 60px;
}

.sp3-content-inner {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 1400px;
  margin: 0 auto;
  padding-top: 41px;
}

.sp3-left-section {
  width: 820px;
  flex-shrink: 0;
}

.sp3-left-title {
  width: 160px;
  height: 53px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 40px;
  color: #FB2911;
  text-align: left;
  font-style: normal;
  text-transform: none;
  line-height: 53px;
  background: linear-gradient(90deg, #FB2911 0%, #930000 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.sp3-focus-list {
  display: flex;
  gap: 41px;
  margin-top: 36px;
}

.sp3-focus-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 390px;
}

.sp3-focus-image-wrap {
  width: 390px;
  height: 233px;
  overflow: hidden;
  background: #E0E0E0;
  border-radius: 4px;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.sp3-focus-image-wrap:hover {
  opacity: 0.85;
}

.sp3-focus-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.sp3-focus-image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
}

.sp3-focus-main-title {
  width: 391px;
  height: auto;
  min-height: 30px;
  margin-top: 35px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 24px;
  color: #000000;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  overflow: hidden;
  cursor: pointer;
  transition: color 0.2s ease;
}

.sp3-focus-main-title:hover {
  color: #CB2F30;
}


.sp3-focus-sub-list {
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-top: 79px;
}

.sp3-focus-sub-row {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.sp3-focus-sub-item {
  width: 270px;
  height: 56px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 18px;
  color: #000000;
  line-height: 56px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  overflow: hidden;
  cursor: pointer;
}

.sp3-focus-sub-item:hover {
  color: #CB2F30;
}

.sp3-focus-sub-divider {
  width: 320px;
  height: 1px;
  border: 1px dashed #D8D8D8;
  border-radius: 0;
  box-sizing: border-box;
  margin-top: 0;
}

.sp3-right-section {
  display: flex;
  flex-direction: column;
  width: 540px;
  height: 731px;
  flex-shrink: 0;
  margin-top: -98px;
}

.sp3-right-card {
  flex: 1;
  width: 540px;
  background: #F9F9F9;
  border-radius: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.sp3-right-header {
  display: flex;
  align-items: center;
  width: 540px;
  height: 99px;
  background: linear-gradient(90deg, #CB2F30 0%, #E96E74 100%);
  box-shadow: 0 4px 8px 1px rgba(219, 79, 81, 0.3);
  border-radius: 10px 10px 10px 10px;
  padding-left: 37px;
  box-sizing: border-box;
  flex-shrink: 0;
}

.sp3-right-title-text {
  display: block;
  width: 160px;
  height: 53px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 40px;
  color: #FFFFFF;
  text-align: left;
  font-style: normal;
  text-transform: none;
  line-height: 53px;
  overflow: hidden;
}

.sp3-right-list {
  flex: 1;
  overflow: hidden;
}

.sp3-right-item {
  display: flex;
  align-items: center;
  width: 540px;
  height: 78px;
  padding: 0 20px;
  box-sizing: border-box;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 20px;
}

.sp3-right-item:hover {
  background: linear-gradient(90deg, #F1E2DF 0%, #E3B7B3 100%);
}

.sp3-right-date {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 92px;
  flex-shrink: 0;
}

.sp3-right-day {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 24px;
  color: #000000;
  line-height: 28px;
  text-align: center;
}

.sp3-right-month {
  width: 92px;
  height: 30px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  line-height: 30px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

.sp3-right-divider {
  width: 2px;
  height: 47px;
  margin-left: 23px;
    margin-right: 42px;
  border-radius: 0;
  background: linear-gradient(228deg, rgba(197, 116, 111, 1), rgba(236, 186, 181, 1));
  mask-image: repeating-linear-gradient(to bottom, #000 0, #000 4px, transparent 4px, transparent 8px);
  -webkit-mask-image: repeating-linear-gradient(to bottom, #000 0, #000 4px, transparent 4px, transparent 8px);
  flex-shrink: 0;
}

.sp3-right-item-title {
  flex: 1;
  height: 56px;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 18px;
  color: #000000;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.sp3-right-bottom-bar {
  width: 540px;
  height: 10px;
  background: linear-gradient(90deg, #BF1607 0%, #9C3535 100%);
  border-radius: 10px 10px 10px 10px;
  flex-shrink: 0;
}
</style>
